import styled from "@emotion/styled";
import type React from "react";
import type { CSSProperties } from "react";

import type { ColorTypes } from "@themes/colors";
import { theme } from "@themes/themes";

type Color = ColorTypes | "currentColor";

interface IconProps {
  icon: string;
  size?: number | string;
  color?: Color;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const Icon: React.FC<IconProps> = ({ icon, size = 16, color = "currentColor", className, onClick }) => {
  const styles: CSSProperties = {
    cursor: onClick ? "pointer" : "inherit",
  };

  return (
    <StyledIcon className={`${icon} ${className ?? ""}`} color={color} size={size} style={styles} onClick={onClick} />
  );
};

const StyledIcon = styled.i<{ size: number | string; color: Color }>`
  display: inline-flex;
  font-size: ${({ size }) => (typeof size === "number" ? `${size}px` : size)};
  color: ${({ color }) => (color === "currentColor" ? "currentColor" : theme.color(color))};
  align-items: center;
  justify-content: center;
`;
